import { render, staticRenderFns } from "./ClientesExibicaoMelhores.vue?vue&type=template&id=253d6c61&scoped=true&"
import script from "./ClientesExibicaoMelhores.vue?vue&type=script&lang=js&"
export * from "./ClientesExibicaoMelhores.vue?vue&type=script&lang=js&"
import style0 from "./ClientesExibicaoMelhores.vue?vue&type=style&index=0&id=253d6c61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253d6c61",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VIcon,VRow})
